import { lcvRoutesBySlug } from "./routes";

export const getLcvRouteSlugs = () => Object.keys(lcvRoutesBySlug);

export const getLcvRouteBySlug = (slug: string) => lcvRoutesBySlug[slug];
